var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatApiErrorMessage } from '../../../util';
import { ConfirmDialog, ErrorMessageBox, FallbackComponent } from '../../common';
import { LocationListPanel } from '../common/LocationListPanel';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { usePersistingLocationSelect } from '../common/usePersistingLocationSelect';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { useConfiguredLocationIds, useLocationsAPI } from '../selectors';
import { StaffSettingsLocationConfigPanel } from './StaffSettingsFormContent';
import { saveLocationStaffSettings, useCopyStaffSettingsFromAPI, useStaffSettingsConfigAPI, useStaffSettingsStatusAPI } from './selectors';
import { createDefaultStaffSettingsFormState } from './types';
import { getStaffSettingsFormError, mapLoadedWorkHoursToForm, staffSettingsFormToPayload } from './validation';
var mapConfigToForm = function (cfg) {
  var _a, _b, _c, _d;
  return {
    avgWeeklyAttrition: (_a = cfg.avgWeeklyAttrition) !== null && _a !== void 0 ? _a : '',
    avgMonthlyAttrition: (_b = cfg.avgMonthlyAttrition) !== null && _b !== void 0 ? _b : '',
    graduationRate: (_c = cfg.graduationRate) !== null && _c !== void 0 ? _c : '',
    recruitingLeadTimeWeeks: (_d = cfg.recruitingLeadTimeWeeks) !== null && _d !== void 0 ? _d : '',
    classSize: cfg.classSize == null ? '' : String(cfg.classSize),
    agent: mapLoadedWorkHoursToForm(cfg.agent),
    support: mapLoadedWorkHoursToForm(cfg.support),
    isDirty: false
  };
};
var workHoursIsPopulated = function (wh) {
  return wh.paidHoursPerDay !== '' && wh.workingDaysPerWeek !== '' && wh.workingDaysPerYear !== '';
};
var formIsConfigured = function (form) {
  return form.avgWeeklyAttrition !== '' && form.avgMonthlyAttrition !== '' && form.graduationRate !== '' && form.recruitingLeadTimeWeeks !== '' && form.classSize !== '' && workHoursIsPopulated(form.agent) && workHoursIsPopulated(form.support) && getStaffSettingsFormError(form, function () {
    return '';
  }) === null;
};
export var StaffSettingsStep = function () {
  var _a;
  var _b = useContext(OrgConfigWizardContext),
    configVersionId = _b.configVersionId,
    setBeforeNext = _b.setBeforeNext,
    selectedLocationId = _b.selectedLocationId,
    setSelectedLocationId = _b.setSelectedLocationId;
  var t = useTranslation('orgConfig', {
    keyPrefix: 'staffSettings'
  }).t;
  var locationsData = useLocationsAPI(configVersionId)[0];
  var allLocations = useMemo(function () {
    var _a, _b;
    return (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
  }, [locationsData.data]);
  var _c = useState({}),
    formMap = _c[0],
    setFormMap = _c[1];
  var _d = useState(undefined),
    globalError = _d[0],
    setGlobalError = _d[1];
  var selectedLocation = useMemo(function () {
    var _a;
    return (_a = allLocations.find(function (l) {
      return l.id === selectedLocationId;
    })) !== null && _a !== void 0 ? _a : null;
  }, [allLocations, selectedLocationId]);
  var _e = useStaffSettingsConfigAPI(selectedLocationId),
    configData = _e[0],
    fetchConfig = _e[1];
  useEffect(function () {
    if (!selectedLocationId) return;
    fetchConfig();
  }, [selectedLocationId, fetchConfig]);
  useEffect(function () {
    if (!selectedLocationId || !configData.data) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[selectedLocationId]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = mapConfigToForm(configData.data), _a));
    });
  }, [selectedLocationId, configData.data]);
  var handleFormChange = useCallback(function (updater) {
    if (!selectedLocationId) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      var current = (_b = prev[selectedLocationId]) !== null && _b !== void 0 ? _b : createDefaultStaffSettingsFormState();
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = updater(current), _a));
    });
  }, [selectedLocationId]);
  var _f = useState(null),
    copySourceId = _f[0],
    setCopySourceId = _f[1];
  var _g = useCopyStaffSettingsFromAPI(selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0, copySourceId),
    copyData = _g[0],
    doCopyFrom = _g[1],
    clearCopyData = _g[2];
  var _h = useState(0),
    copyDropdownKey = _h[0],
    setCopyDropdownKey = _h[1];
  var _j = useState(false),
    clearConfirmOpen = _j[0],
    setClearConfirmOpen = _j[1];
  var _k = useState(undefined),
    copyError = _k[0],
    setCopyError = _k[1];
  var dismissedCopyErrorRef = useRef(null);
  var handleCopyFrom = useCallback(function (sourceLocationId) {
    dismissedCopyErrorRef.current = null;
    setCopyError(undefined);
    setCopySourceId(sourceLocationId);
    setCopyDropdownKey(function (k) {
      return k + 1;
    });
  }, []);
  useEffect(function () {
    if (copySourceId) doCopyFrom();
  }, [copySourceId, doCopyFrom]);
  useEffect(function () {
    var copied = copyData.data;
    if (!copied || !selectedLocationId) return;
    setFormMap(function (prev) {
      var _a;
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = __assign(__assign({}, mapConfigToForm(copied)), {
        isDirty: false
      }), _a));
    });
    clearCopyData();
    setCopySourceId(null);
    if (selectedLocationId) fetchConfig();
  }, [copyData.data, selectedLocationId, clearCopyData, fetchConfig]);
  useEffect(function () {
    if (!copyData.error) {
      dismissedCopyErrorRef.current = null;
      return;
    }
    if (dismissedCopyErrorRef.current === copyData.error) return;
    var fallback = t('errors.copyFailed', {
      defaultValue: 'Failed to copy staff settings. Please try again.'
    });
    var message = formatApiErrorMessage(copyData.error, fallback);
    setCopyError(function (prev) {
      return (prev === null || prev === void 0 ? void 0 : prev.message) === message ? prev : {
        message: message
      };
    });
  }, [copyData.error, t]);
  var handleCloseCopyError = useCallback(function () {
    dismissedCopyErrorRef.current = copyData.error;
    setCopyError(undefined);
  }, [copyData.error]);
  var handleClearData = useCallback(function () {
    if (!selectedLocationId) return;
    setFormMap(function (prev) {
      var _a;
      var cur = prev[selectedLocationId];
      if (!cur) return prev;
      return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = __assign(__assign({}, createDefaultStaffSettingsFormState()), {
        isDirty: true
      }), _a));
    });
    setClearConfirmOpen(false);
  }, [selectedLocationId]);
  var _l = useStaffSettingsStatusAPI(configVersionId),
    statusData = _l[0],
    fetchStatus = _l[1];
  var configuredLocationIds = useConfiguredLocationIds(fetchStatus, statusData);
  var getLocationStatus = useCallback(function (id) {
    var form = formMap[id];
    if (form) return formIsConfigured(form) ? 'ok' : 'incomplete';
    return configuredLocationIds.has(id) ? 'ok' : 'incomplete';
  }, [formMap, configuredLocationIds]);
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var allLocationsRef = useRef(allLocations);
  useEffect(function () {
    allLocationsRef.current = allLocations;
  }, [allLocations]);
  var persistCurrentLocation = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var form, validationError, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!selectedLocationId) return [2 /*return*/, true];
            form = formMapRef.current[selectedLocationId];
            if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [2 /*return*/, true];
            validationError = getStaffSettingsFormError(form, t);
            if (validationError) {
              setGlobalError({
                message: validationError
              });
              return [2 /*return*/, false];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, saveLocationStaffSettings(selectedLocationId, staffSettingsFormToPayload(form))];
          case 2:
            _a.sent();
            setFormMap(function (prev) {
              var _a;
              var cur = prev[selectedLocationId];
              if (!cur) return prev;
              return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = __assign(__assign({}, cur), {
                isDirty: false
              }), _a));
            });
            fetchStatus();
            return [2 /*return*/, true];
          case 3:
            err_1 = _a.sent();
            setGlobalError({
              message: formatApiErrorMessage(err_1, t('errors.saveFailed', {
                defaultValue: 'Failed to save staff settings. Please try again.'
              }))
            });
            return [2 /*return*/, false];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }, [selectedLocationId, t, fetchStatus]);
  var _m = usePersistingLocationSelect({
      selectedLocationId: selectedLocationId,
      setSelectedLocationId: setSelectedLocationId,
      persistCurrent: persistCurrentLocation
    }),
    onSelectLocation = _m.onSelectLocation,
    isPersistingSelection = _m.isPersistingSelection;
  useEffect(function () {
    var beforeNextFn = function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var fm, locations, _i, locations_1, loc, form, validationError, _a, locations_2, loc, form, err_2;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              fm = formMapRef.current;
              locations = allLocationsRef.current;
              setGlobalError(undefined);
              for (_i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
                loc = locations_1[_i];
                form = fm[loc.id];
                if (!form) continue;
                validationError = getStaffSettingsFormError(form, t);
                if (validationError) {
                  setSelectedLocationId(loc.id);
                  setGlobalError({
                    message: validationError
                  });
                  return [2 /*return*/, false];
                }
              }
              _b.label = 1;
            case 1:
              _b.trys.push([1, 6,, 7]);
              _a = 0, locations_2 = locations;
              _b.label = 2;
            case 2:
              if (!(_a < locations_2.length)) return [3 /*break*/, 5];
              loc = locations_2[_a];
              form = fm[loc.id];
              if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return [3 /*break*/, 4];
              return [4 /*yield*/, saveLocationStaffSettings(loc.id, staffSettingsFormToPayload(form))];
            case 3:
              _b.sent();
              _b.label = 4;
            case 4:
              _a++;
              return [3 /*break*/, 2];
            case 5:
              fetchStatus();
              return [2 /*return*/, true];
            case 6:
              err_2 = _b.sent();
              setGlobalError({
                message: formatApiErrorMessage(err_2, t('errors.saveFailed', {
                  defaultValue: 'Failed to save staff settings. Please try again.'
                }))
              });
              return [2 /*return*/, false];
            case 7:
              return [2 /*return*/];
          }
        });
      });
    };
    setBeforeNext(beforeNextFn);
    return function () {
      return setBeforeNext(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setBeforeNext]);
  var checkIsDirty = useCallback(function () {
    return Object.values(formMapRef.current).some(function (form) {
      return form.isDirty;
    });
  }, []);
  useOrgConfigDirtyRegister(checkIsDirty);
  var currentForm = selectedLocationId === null ? null : (_a = formMap[selectedLocationId]) !== null && _a !== void 0 ? _a : null;
  var isLoading = configData.requesting;
  return _jsxs(_Fragment, {
    children: [_jsx(ErrorMessageBox, {
      errors: [globalError],
      onClose: function () {
        return setGlobalError(undefined);
      }
    }), _jsx(OrgConfigStepContainer, __assign({
      leftContent: _jsx(LocationListPanel, {
        allLocations: allLocations,
        selectedLocationId: selectedLocationId,
        onSelectLocation: onSelectLocation,
        getLocationStatus: getLocationStatus,
        title: t('locations.title', {
          defaultValue: 'Site locations'
        }),
        description: t('locations.description', {
          defaultValue: 'Select a location to view/edit data.'
        })
      })
    }, {
      children: !selectedLocation || !currentForm ? _jsx(Box, __assign({
        sx: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 300
        }
      }, {
        children: _jsx(Typography, __assign({
          color: "text.secondary"
        }, {
          children: isLoading ? t('loading', {
            defaultValue: 'Loading…'
          }) : t('selectLocation', {
            defaultValue: 'Select a location to configure staff settings.'
          })
        }))
      })) : _jsx(StaffSettingsLocationConfigPanel, {
        form: currentForm,
        locationId: selectedLocationId,
        allLocations: allLocations,
        onChange: handleFormChange,
        onCopyFrom: handleCopyFrom,
        onClear: function () {
          return setClearConfirmOpen(true);
        },
        isCopying: !!copyData.requesting,
        copyDropdownKey: copyDropdownKey
      })
    })), _jsx(ErrorMessageBox, {
      errors: [copyError],
      onClose: handleCloseCopyError,
      scrollTop: false
    }), _jsx(ConfirmDialog, {
      open: clearConfirmOpen,
      onClose: function () {
        return setClearConfirmOpen(false);
      },
      title: t('clearDataConfirm.title', {
        defaultValue: 'Clear staff settings'
      }),
      message: t('clearDataConfirm.message', {
        defaultValue: 'Are you sure you want to clear all staff settings for this location?'
      }),
      onConfirm: handleClearData,
      confirmButtonText: "yes",
      cancelButtonText: "cancel"
    }), _jsx(FallbackComponent, {
      requesting: isPersistingSelection,
      overlay: true
    })]
  });
};